
import React from 'react';
import { Icons } from '../constants';

interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ activePage, onNavigate }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Icons.Dashboard },
    { id: 'websites', label: 'My Websites', icon: Icons.Globe },
    { id: 'marketing', label: 'Marketing Tools', icon: Icons.Megaphone },
    { id: 'clients', label: 'Client Manager', icon: Icons.Users },
    { id: 'settings', label: 'Settings', icon: Icons.Settings },
  ];

  return (
    <aside className="w-64 bg-white border-r border-slate-200 flex flex-col h-screen sticky top-0">
      <div className="p-6">
        <div className="flex items-center gap-3 text-indigo-600">
          <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
            <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 text-white" stroke="currentColor" strokeWidth="2.5"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.34-.5 4.63-2.25c1.32-1.8 2.37-4.14 2.87-6.75M4.5 16.5l3-3m-3 3 1.5 1.5m1.5-1.5 4-4m-7 7 3-3m0 0 4-4m-4 4 1.5 1.5m4-4 3.5-3.5m-3.5 3.5 1.5 1.5m1.5-1.5 3-3m-3 3 1.5 1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <span className="font-bold text-xl tracking-tight text-slate-900">WebFlow AI</span>
        </div>
      </div>

      <nav className="flex-1 px-4 py-4 space-y-1">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              activePage === item.id 
                ? 'bg-indigo-50 text-indigo-600' 
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
            }`}
          >
            <item.icon />
            {item.label}
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-100">
        <div className="bg-indigo-600 rounded-xl p-4 text-white">
          <p className="text-xs font-medium opacity-80 mb-1">Current Plan</p>
          <p className="font-bold mb-3">Enterprise Pro</p>
          <button className="w-full bg-white text-indigo-600 text-xs font-bold py-2 rounded-lg hover:bg-slate-50 transition-colors">
            Manage Subscription
          </button>
        </div>
      </div>
    </aside>
  );
};
